import { Avatar, Box, IconButton, Tooltip, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { ITeamUser } from '@common/types';
import { ConfirmationModal } from 'components/ConfirmationModal';
import { t } from 'i18next';
import { useSidebarMember } from './hooks/useSidebarMember';
import { theme } from '@store';

interface ISidebarMemberProps {
  teamId: string;
  user: ITeamUser;
}

export const SidebarMember = ({ teamId, user }: ISidebarMemberProps) => {
  const { isModalOpen, handleOpen, handleClose, handleConfirm } =
    useSidebarMember({ teamId, user });

  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.grey[300]}`,
        paddingY: 2,
        paddingX: 2,
        mb: 1,
        alignItems: 'center',
      }}
    >
      <Avatar
        sx={{
          width: '20px',
          height: '20px',
          backgroundcolor: 'primary.main',
          mr: '11px',
        }}
        src='/broken-image.jpg'
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'regular',
            fontSize: '0.87rem',
            color: 'text.primary',
          }}
        >
          {user.full_name}
        </Typography>
        <Tooltip
          title={t('adminPanel.teams.drawer.membersTab.setTeamLeadLabel')}
          placement='bottom'
        >
          <IconButton
            disabled={user.lead}
            aria-label={
              user.lead
                ? ''
                : t('adminPanel.teams.drawer.membersTab.setTeamLeadLabel')
            }
            onClick={handleOpen}
          >
            <StarIcon
              color={user.lead ? 'primary' : 'disabled'}
              sx={{ fontSize: 21 }}
            />
          </IconButton>
        </Tooltip>
        <ConfirmationModal
          title={t('adminPanel.teams.drawer.membersTab.teamLeadModal.title')}
          message={t(
            'adminPanel.teams.drawer.membersTab.teamLeadModal.description',
            {
              name: user.full_name,
            },
          )}
          isOpen={isModalOpen}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      </Box>
    </Box>
  );
};
